import Vue from "vue";
import store from "@/store";
import Router from "vue-router";
import Layout from "@/views/layout/index";
import { loadLanguageAsync } from "@/lang/index";

Vue.use(Router);

const zackRouter = [
  {
    path: "d5Lotre", // 5d-lotre
    name: "D5Lotre",
    component: () =>
      import(/* webpackChunkName: "D5Lotre" */ "@/views/5d/index.vue"),
    meta: {
      keepAlive: true
    }
  },
  {
    path: "racing", // racing
    name: "Racing",
    component: () =>
      import(/* webpackChunkName: "Racing" */ "@/views/racing/index.vue"),
    meta: {
      keepAlive: true
    }
  },
  {
    path: "airship", // airship
    name: "Airship",
    component: () =>
      import(/* webpackChunkName: "Airship" */ "@/views/airship/index.vue"),
    meta: {
      keepAlive: true
    }
  },
  {
    path: "k3Lotre", // k3-lotre
    name: "k3Lotre",
    component: () =>
      import(/* webpackChunkName: "k3Lotre" */ "@/views/k3-lotre/index.vue"),
    meta: {
      keepAlive: true
    }
  },
  {
    path: "winGo", // win-go
    name: "winGo",
    component: () =>
      import(/* webpackChunkName: "winGo" */ "@/views/win-go/index.vue"),
    meta: {
      keepAlive: true
    }
  },
  {
    path: "trxWinGo", // trx-win-go
    name: "TrxWinGo",
    component: () =>
      import(/* webpackChunkName: "TrxWinGo" */ "@/views/trx-win-go/index.vue"),
    meta: {
      keepAlive: true
    }
  },
  {
    path: "bettingdes", // bettingdes
    name: "bettingdes",
    component: () =>
      import(/* webpackChunkName: "bettingdes" */ "@/views/bettingdes/index.vue")
  },
  {
    path: "liuhe",
    name: "liuhe",
    component: () =>
      import(/* webpackChunkName: "liuhe" */ "@/views/liuhe/index.vue"),
    meta: {
      keepAlive: true
    }
  }
  // {
  //   path: "buyLottery/:id",
  //   name: "buyLottery",
  //   component: () =>
  //     import(/* webpackChunkName: "buyLottery" */ "@/views/buy-lottery/buy_lottery"),
  //   meta: {
  //     notFooter: true,
  //   },
  // },
  // {
  //   path: "prizeNotice",
  //   name: "prizeNotice",
  //   component: () =>
  //     import(/* webpackChunkName: "prizeNotice" */ "@/views/prize-notice/prizeNotice"),
  //   meta: {
  //     keepAlive: true,
  //     notFooter: true,
  //   },
  // },
  // {
  //   path: "historyList/:id",
  //   name: "historyList",
  //   component: () =>
  //     import(/* webpackChunkName: "historyList" */ "@/views/prize-notice/historyList"),
  //   meta: {
  //     notFooter: true,
  //   },
  // },
  // {
  //   path: "brandList/:code",
  //   name: "brandList",
  //   component: () =>
  //     import(/* webpackChunkName: "brandList" */ "@/views/brand-games/brand-list"),
  //   meta: {
  //     notFooter: true,
  //   },
  // },
  // {
  //   path: "/trend/:id",
  //   name: "trend",
  //   component: () =>
  //     import(/* webpackChunkName: "trend" */ "@/views/trend/trend"),
  //   meta: {
  //     keepAlive: true,
  //     notFooter: true,
  //   },
  // },
  // {
  //   path: "lotteryTypeRule",
  //   name: "lotteryTypeRule",
  //   component: () =>
  //     import(/* webpackChunkName: "lotteryTypeRule" */ "@/views/personal-center/child_modal/lottery_type_rule/lottery_type_rule"),
  //   meta: {
  //     notFooter: true,
  //   },
  // },
  // {
  //   path: "bettingList",
  //   name: "bettingList",
  //   component: () =>
  //     import(/* webpackChunkName: "bettingList" */ "@/views/bettingList/index.vue"),
  //   meta: {
  //     keepAlive: false,
  //     notFooter: true,
  //   },
  // children: [
  //   {
  //     path: "/bettingDetail/:id",
  //     name: "bettingDetail",
  //     component: () =>
  //       import(/* webpackChunkName: "bettingDetail" */ "@/views/bettingList/bDetail"),
  //     meta: {
  //       notFooter: true,
  //     },
  //   },
  //   {
  //     path: "/agentBettingDetail/:id",
  //     name: "agentBettingDetail",
  //     component: () =>
  //       import(/* webpackChunkName: "bettingDetail" */ "@/views/bettingList/bDetail"),
  //     meta: {
  //       notFooter: true,
  //     },
  //   },
  // ],
  // },
];

let setRoute = new Router({
  // mode: "history",
  routes: [
    {
      path: "*",
      component: () => import(/* webpackChunkName: "404" */ "@/views/404")
    },
    {
      path: "/503",
      name: "503",
      component: () => import(/* webpackChunkName: "503" */ "@/views/503")
    },
    {
      path: "/",
      component: Layout,
      redirect: "racing",
      children: [
        ...zackRouter,
        {
          path: "buyLottery/:id",
          name: "buyLottery",
          component: () =>
            import(/* webpackChunkName: "buyLottery" */ "@/views/buy-lottery/buy_lottery"),
          meta: {
            notFooter: true
          }
        }
        // {
        //   path: "home",
        //   component: () =>
        //     import(/* webpackChunkName: "home" */ "@/views/home/index"),
        //   name: "home",
        //   redirect: 'lotteryHalls/all',
        //   meta: {
        //     keepAlive: true,
        //   },
        // children: [{
        //   path: "lottery",
        //   name: "home",
        //   component: () =>
        //     import(/* webpackChunkName: "home" */ "@/views/home/components/lottery"),
        //   meta: {
        //     keepAlive: true,
        //   },
        // },
        // {
        //   path: "games/:code",
        //   name: "home",
        //   component: () =>
        //     import(/* webpackChunkName: "home" */ "@/views/home/components/games"),
        //   meta: {
        //     keepAlive: true,
        //   },
        // },
        // ],
        // },
        // {
        //   path: "hotlist",
        //   name: "hotlist",
        //   component: () =>
        //     import(/* webpackChunkName: "hotlist" */ "@/views/home/components/hotlist"),
        //   meta: {
        //     notFooter: true,
        //   },
        // },
        // {
        //   path: "login",
        //   name: "login",
        //   component: () =>
        //     import(/* webpackChunkName: "loginRegister" */ "@/views/login"),
        //   meta: {
        //     notFooter: true,
        //   },
        // },
        // {
        //   path: "register",
        //   name: "register",
        //   component: () =>
        //     import(/* webpackChunkName: "register" */ "@/views/register"),
        //   meta: {
        //     notFooter: true,
        //   },
        // },
      ]
    }
  ],
  scrollBehavior(_, __, savedPosition) {
    return (
      savedPosition || {
        x: 0,
        y: 0
      }
    );
  }
});
//截取进入路由的上一个页面

let history = sessionStorage;
let paths = [
    "home",
    "lottery",
    "prizeNotice",
    "discovery",
    "personalCenter",
    "chatMain"
  ],
  initPaths = {};
for (let itemPath of paths) {
  initPaths["/" + itemPath] = 1;
}
initPaths["/agencyCenter"] = 2;
history.setItem("historyPaths", JSON.stringify(initPaths));

//路由跳转之后执行
setRoute.afterEach(() => {
  const skeletonDom = document.getElementById("skeleton-contanier");
  if (skeletonDom) {
    skeletonDom.parentNode.removeChild(skeletonDom);
  }
});

// console.log(setRoute, '--------------------------------------')

export default setRoute;
